import { IHoverStatistics } from '../interfaces/IHoverStatistics';

const aboutHoverStatistics: IHoverStatistics[] = [
  {
    title: 'HOVER LAUNCHES',
    value: '2011',
  },
  {
    title: 'EMPLOYEES',
    value: '300+',
  },
  {
    value: '2',
    title: 'NATIONAL OFFICES',
  },
  {
    title: 'HOMEOWNERS SERVED',
    value: '1M+',
  },
];

export default aboutHoverStatistics;
